import React, { useEffect, useRef } from "react";

const AboutCircle = () => {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;

    const ctx = canvas.getContext("2d");

    // Responsive canvas sizing
    const isMobile = window.innerWidth <= 768;
    const isSmallMobile = window.innerWidth <= 480;

    let canvasSize;
    if (isSmallMobile) {
      canvasSize = Math.min(280, window.innerWidth - 40);
    } else if (isMobile) {
      canvasSize = Math.min(350, window.innerWidth - 40);
    } else {
      canvasSize = 550;
    }

    canvas.width = canvasSize;
    canvas.height = canvasSize;

    let time = 0;
    const phi = (1 + Math.sqrt(5)) / 2;
    let animationFrameId = null;

    const animate = () => {
      ctx.fillStyle = "#000000";
      ctx.fillRect(0, 0, canvas.width, canvas.height);

      ctx.save();
      ctx.translate(canvas.width / 2, canvas.height / 2);

      const maxRectangles = Math.min(60, Math.floor((time * 0.0392) % 80));

      // Scale animation proportionally to canvas size
      const scaleFactor = canvasSize / 550;
      let width = 300 * scaleFactor;
      let height = width / phi;
      let scale = 1;
      let angle = time * 0.00049;

      for (let i = 0; i < maxRectangles; i++) {
        ctx.save();

        const spiralAngle = i * 0.174533;
        const radius = scale * 100 * scaleFactor;
        const x = Math.cos(spiralAngle) * radius;
        const y = Math.sin(spiralAngle) * radius;

        ctx.translate(x, y);
        ctx.rotate(spiralAngle + angle);

        const alpha = 0.7 - i * 0.01;

        // Cycle through pastel primary colors
        const colorIndex = i % 3;
        let strokeColor;
        if (colorIndex === 0) {
          strokeColor = `rgba(255, 182, 193, ${alpha})`; // Pastel red
        } else if (colorIndex === 1) {
          strokeColor = `rgba(173, 216, 230, ${alpha})`; // Pastel blue
        } else {
          strokeColor = `rgba(255, 255, 182, ${alpha})`; // Pastel yellow
        }

        ctx.strokeStyle = strokeColor;
        ctx.lineWidth = 0.8;
        ctx.strokeRect(-width / 2, -height / 2, width, height);

        if (i % 3 === 0) {
          ctx.beginPath();
          ctx.moveTo(-width / 2, -height / 2);
          ctx.lineTo(width / 2, height / 2);
          ctx.moveTo(width / 2, -height / 2);
          ctx.lineTo(-width / 2, height / 2);
          ctx.strokeStyle = `rgba(220, 220, 220, ${alpha * 0.3})`;
          ctx.lineWidth = 0.5;
          ctx.stroke();
        }

        ctx.restore();

        width *= 0.95;
        height *= 0.95;
        scale *= 0.98;
      }

      ctx.beginPath();
      for (let i = 0; i <= maxRectangles; i++) {
        const spiralAngle = i * 0.174533;
        const radius = Math.pow(0.98, i) * 100 * scaleFactor;
        const x = Math.cos(spiralAngle) * radius;
        const y = Math.sin(spiralAngle) * radius;

        if (i === 0) ctx.moveTo(x, y);
        else ctx.lineTo(x, y);
      }

      ctx.strokeStyle = "rgba(180, 180, 180, 0.4)";
      ctx.lineWidth = 1;
      ctx.stroke();

      ctx.restore();

      time += 1.47;
      animationFrameId = requestAnimationFrame(animate);
    };

    animate();

    return () => {
      if (animationFrameId) {
        cancelAnimationFrame(animationFrameId);
      }
      if (ctx) {
        ctx.clearRect(0, 0, canvas.width, canvas.height);
      }
    };
  }, []);

  return (
    <div className="flex items-center justify-center w-full h-full bg-black">
      <div
        className="bg-black"
        style={{ width: "100%", maxWidth: "550px", aspectRatio: "1/1" }}
      >
        <canvas ref={canvasRef} className="w-full h-full" />
      </div>
    </div>
  );
};

export default AboutCircle;
